<template>
  <div>
    <div class="search-view" v-if="tagSearchList.length > 0 && !isReSelectTag">
      <div class="search-header" ref="searchHeader">
        <search-input v-if="searchCategory === 'all'" />
        <search-header-title v-else :search-category="searchCategory" :m-type="mType"/>
        <template v-if="searchCategory === 'all'">
          <div class="tag-search-list">
            <div class="flex-wrapper">
              <div class="tag-item"
                   @click.prevent="()=>deleteTagOne(tag)"
                   v-for="(tag, index) in tagSearchList"
                   :key="tag.text+index">
                <span class="tag-item-txt">{{tag.text}}</span>
                <div class="delete-tag-icon">
                  <TagDeleteButton/>
                </div>
              </div>
            </div>
          </div>
          <div class="tag-refresh">
            <button type="button" class="tag-refresh-button" @click.prevent="reSelectTag">
              <RefreshTagListButton/>
              <span class="tag-refresh-txt">태그 재검색</span>
            </button>
          </div>
        </template>
      </div>
        <search-tag-result-band v-if="isTagSearchLoaded && searchCategory === 'all'"
                                     :tag-search-list="tagSearchList"
                                     :search-category="searchCategory"
                                     :search-type="currentTab"
                                     :m-type="mType"
                                     :multisection-list="multisectionList"
        />
        <search-result-list v-if="searchCategory !== 'all'"
                            :type="searchCategory"
                            :tag-search-list="tagSearchList"
                            :m-type="mType"
                            :key="currentTab + '_' + mType" />
      </div>
    <search-tag-catalog v-else
              :prev-tag-list="tagSearchList"
              :prev-tab-type="currentTab"
              :tag-list-close-fn="tagListClose"
              class="lnb-slide-duration" />
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { SearchService } from '@/common/api/api.service'
import { get } from 'lodash'
import { EventBus } from '@/components/eventbus/EventBus'
import SearchTagCatalog from '@/components/search/SearchTagCatalog'
import SearchTagResultBand from '@/components/search/SearchTagResultBand'
import MultiSectionModel from '@/common/model/MultiSectionModel'
import TagDeleteButton from '@/assets/svg/common/ic-delete-tag.svg'
import RefreshTagListButton from '@/assets/svg/common/ic-replay-w.svg'
import SearchInput from '@/components/search/SearchInput'
import SearchHeaderTitle from '@/components/search/SearchHeaderTitle'
import SearchResultList from '@/components/search/SearchResultList'
import { SEARCH_BY_TAG } from '@/common/util/eventbus.const'
import { sendEventLogCloseTagSearchPopup, sendEventLogTagReSearch } from '@/common/util/log.v2.send'
import { setTransactionKeyToStorage } from '@/common/util/storage.util'

export default {
  name: 'SearchTag',
  components: {
    SearchHeaderTitle,
    SearchInput,
    SearchTagCatalog,
    SearchTagResultBand,
    TagDeleteButton,
    RefreshTagListButton,
    SearchResultList
  },
  data () {
    return {
      currentTab: 'vod', // vod, movie
      // tagSearchList: [],
      multisectionList: [],
      selectedTagList: {
        vod: [],
        movie: []
      },
      isTagSearchLoaded: false,
      isReSelectTag: false,
      searchCategory: 'all',
      mType: 'all'
    }
  },
  computed: {
    ...mapGetters(['tagSearchList', 'tagTabType'])
  },
  methods: {
    ...mapMutations(['deleteTag']),
    setSearchTagData () {
      this.isTagSearchLoaded = false
      SearchService.tagAllSearch({
        limit: 20,
        offset: 0,
        orderby: 'score',
        type: this.currentTab,
        searchtags: this.tagSearchList
      }).then(({ data }) => {
        this.multisectionList = Number(get(data, 'totalcount', 0)) > 0
          ? get(data, 'multisectionlist', []).map((multiSection) => {
            return new MultiSectionModel(multiSection)
          })
          : []
        setTransactionKeyToStorage(data)
        this.isTagSearchLoaded = true
      })
    },
    searchByTag ({ tab }) {
      this.isReSelectTag = false
      this.currentTab = tab
      this.setSearchTagData()
    },
    deleteTagOne (tag) {
      this.deleteTag(tag)
      if (this.tagSearchList.length === 0) {
        this.$router.replace('/search')
      } else {
        this.setSearchTagData()
      }
    },
    reSelectTag () {
      sendEventLogTagReSearch({ type: this.currentTab })
      this.isReSelectTag = true
    },
    init () {
      this.currentTab = this.tagTabType
      this.mType = get(this.$route, 'query.mType', 'all')
      this.searchCategory = get(this.$route, 'query.searchCategory', 'all')
      window.scrollTo(0, 0)
    },
    tagListClose () {
      sendEventLogCloseTagSearchPopup({ type: this.currentTab })
      if (this.tagSearchList.length > 0) {
        this.isReSelectTag = false
      } else {
        this.$router.back()
      }
    }
  },
  created () {
    EventBus.$on(SEARCH_BY_TAG, this.searchByTag)
    this.init()
    if (this.tagSearchList.length > 0) {
      this.setSearchTagData()
    }
  },
  beforeDestroy () {
    EventBus.$off(SEARCH_BY_TAG, this.searchByTag)
  },
  watch: {
    $route () {
      this.init()
    }
  }
}
</script>
<style lang="css" src="@/assets/new-css/search.css"></style>
